import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import Script from 'next/script'

import { getScreenName } from 'state/screen/selectors'
import { getIsCookieConsentVersion } from 'state/consent/selectors'

import { MapScreenToSasPageId } from 'constants/ads'
import useLocation from 'hooks/useLocation'

import { initSmartAdServer, getSmartAdServerSiteId } from './utils'

const SmartAdServer = () => {
  const screenName = useSelector(getScreenName)
  const isCookieConsentVersion = useSelector(getIsCookieConsentVersion)

  const smartAdServerSiteId = getSmartAdServerSiteId(useLocation().host)
  const smartAdServerPageId = MapScreenToSasPageId[screenName]
  const isSmartAdServerIds = !!smartAdServerSiteId && !!smartAdServerPageId
  const shouldRenderSmartAdServer = !isCookieConsentVersion && isSmartAdServerIds

  useEffect(() => {
    if (shouldRenderSmartAdServer) {
      initSmartAdServer(smartAdServerSiteId, smartAdServerPageId)
    }
  }, [shouldRenderSmartAdServer, smartAdServerSiteId, smartAdServerPageId])

  if (!shouldRenderSmartAdServer) return null

  return (
    <Script
      id="smart-adserver-script"
      data-testid="smart-adserver-script"
      src="//ced.sascdn.com/tag/3230/smart.js"
      strategy="lazyOnload"
    />
  )
}

export default SmartAdServer
